import axios from "axios";
import { refreshTokens } from "./AuthService";
import Cookies from "universal-cookie";
import { jwtDecode } from 'jwt-decode';

const client = axios.create({
    //baseURL: "http://localhost:8000/users"
    baseURL: "https://vp-backend-ysy4bqirgq-uc.a.run.app/users" 
});

const cookies = new Cookies();
client.defaults.headers.common['Authorization'] = 'Bearer ' + cookies.get("jwt_authorization");


client.interceptors.response.use(resp => resp, async error => {   
    if (error.response.status === 401) {
        const data = {
            'refresh_token': cookies.get("refresh_token")
        }
        const response = await refreshTokens(JSON.stringify(data));

        if (response.id_token !== null) {
            client.defaults.headers.common['Authorization'] = 'Bearer ' + response.id_token;
            var userObject = jwtDecode(response.id_token);
            cookies.set("jwt_authorization", response.id_token, {
                expires: new Date(userObject.exp * 1000),
            });
            cookies.set("access_token", response.access_token, {
                expires: new Date(userObject.exp * 1000),
            });
            window.location.reload();
            return client(error.config);
        }
    }
});

export const getAllEmployees = async () => {
    const promise = client.get('?skip=0&limit=100');
    const data = promise.then((response) => response.data);
    return data;
};

export const getActiveEmployees = async () => {
    const promise = client.get('/active');
    const data = promise.then((response) => response.data);
    return data;
};

export const getEmployeeById = async (id) => {
    const promise = client.get(id);
    const data = promise.then((response) => response.data);
    return data;
};

export const validateEmployee = async (params) => {
    const promise = client.post('/validate_user', params, {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    });
    const data = promise.then((response) => response.data);
    return data;
};

export const deleteEmployee = (body) => {
    const promise = client.post('/delete', body, {
        headers: {
            'Accept': '*/*',
            'Content-Type': 'application/json'
        }
    });
    const data = promise.then((response) => response.data);
    return data;
};

export const setResponsible = (body) => {
    const promise = client.post('/set_responsible', body, {
        headers: {
            'Accept': '*/*',
            'Content-Type': 'application/json'
        }
    });
    const data = promise.then((response) => response);
    return data;
};